export enum userConfigAction {
  getCredential = '@Validate/CREDENTIAL_USER',
  validate = '@Validate/VALIDATE_USER',
  getUser = '@Validate/GET_USER_VALIDATED',
  confirmErrorToken = '@Validate/CONFIRM_ERROR_TOKEN',
  confirmErrorDigit = '@Validate/CONFIRM_ERROR_DIGIT'
}

export const validateCheckUser = (payload: GQL.IValidateUserOnQueryArguments) => ({
  type: userConfigAction.getCredential,
  payload,
});

export const getUserValidated = (userConfig:ConfigUser) => ({
  type: userConfigAction.getUser,
  payload:userConfig
});

export const confirmUser = (data:ValidateCPF) => ({
  type: userConfigAction.validate,
  payload:data
});


export const confirmErrorToken = (value:boolean) => ({
  type: userConfigAction.confirmErrorToken,
  payload:value
});

export const confirmErrorDigit = (value:boolean) => ({
  type: userConfigAction.confirmErrorDigit,
  payload:value
});
